export default __webpack_public_path__ + "static/media/live-icon.9264e513.webp";